import React from "react";
import PropTypes from "prop-types";
import { Stepper } from "@progress/kendo-react-layout";
import "./Stepper.scss";

/**
 * Stepper component
 * @module
 * @param {array} items - Stepper items
 * @param {number} value - Stepper position value
 * @param {func} handleChange - Handle change function
 * @param {string} [name] - Name
 * @param {bool} [linear] - Linear mode
 * @param {bool} [disabled] - Disabled stepper
 */
const StepperComponent = (props) => {
  const getItems = () => {
    if (!props.linear) {
      return props.items;
    }

    let items = props.items.map((item) => ({ ...item, disabled: false }));
    items = items.map((x, index) => {
      if (
        index > props.value + 1 ||
        (index > 0 && items[index - 1].isValid === false)
      ) {
        x.disabled = true;
      }
      return x;
    });
    return items;
  };

  const handleChange = (e) => {
    props.handleChange(e.value, props.name);
  };

  return (
    <Stepper
      items={getItems()}
      value={props.value}
      onChange={handleChange}
      disabled={props.disabled}
      successIcon={"k-icon k-i-check-circle"}
      errorIcon={"k-icon k-i-close-outline"}
    />
  );
}

StepperComponent.propTypes = {
  items: PropTypes.array.isRequired,
  value: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  linear: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default StepperComponent;
